// Third party imports

// App imports
import EditInput from '../../../../components/Input';
import { useEffect, useState } from 'react';
import { formatDate } from 'src/utils/helpers';
import { Button, Flex, Tooltip, Typography } from 'antd';
import {
  DownOutlined,
  FileOutlined,
  PlusCircleFilled,
  SearchOutlined,
  UpOutlined,
} from '@ant-design/icons';
import AntDButton from 'src/components/Button';
import en from 'src/messages/en.json';
export const GridTableBodyRow = ({
  row,
  rowHeaders,
  index,
  update,
  toggleActivity,
  onAddNewRow,
  onBodyRowTotalHeaderDurationChange,
  disabled,
  startDate,
  onClick,
  teamtime,
  reporteeSelected,
  isEnhancementProject,
  disabledNotes,
}) => {
  const [value, setValue] = useState(
    rowHeaders.reduce((acc, col) => acc + col.duration, 0),
  );

  const onChange = (e, rowIndex) => {
    const parseValue = Number(e.target.value);

    setValue(parseValue);
    onBodyRowTotalHeaderDurationChange(parseValue, rowIndex);
  };

  useEffect(() => {
    setValue(rowHeaders.reduce((acc, col) => acc + col.duration, 0));
  });

  const givenDate = formatDate(row.deactivatedDate);

  const start = formatDate(startDate);

  const isRestricted =
    givenDate && start && (givenDate <= start || givenDate === start);

  const backgroundColor = row.isExpanded && !isRestricted ? '#F6F7F9' : 'white';

  return (
    <Flex
      style={{
        backgroundColor,
        borderBottom: '1px solid #F0F0F0',
      }}
      className="input-row"
      key={row.projectId + index}
    >
      <Flex align="center" style={{ width: '33%', padding: '0 0.75rem' }}>
        <Flex
          align="center"
          justify="space-between"
          style={{ width: '100%' }}
          gap={'middle'}
        >
          <Tooltip title={row.projectName || '-'}>
            <Typography.Text
              style={{
                flex: 0.8,
                textAlign: 'left',
              }}
              ellipsis
            >
              {(!teamtime ||
                (teamtime &&
                  reporteeSelected &&
                  row?.note?.trim()?.length > 0)) && (
                <div className="relative inline-flex items-center">
                  <AntDButton
                    type="link"
                    onClick={() => onClick(row)}
                    prefixIcon={<FileOutlined />}
                    htmlType="button"
                    style={{ padding: 0, marginRight: 0 }}
                    disabled={disabledNotes}
                  />

                  {!teamtime && isEnhancementProject(row) && (
                    <span className="absolute text-red-500 right-[2px] top-[2px]">
                      *
                    </span>
                  )}
                </div>
              )}
              &nbsp;
              {row.projectName || '-'}
            </Typography.Text>
          </Tooltip>

          {!isRestricted && row?.activityRows?.length > 0 && (
            <Button
              type="link"
              onClick={() => toggleActivity(row)}
              icon={
                row.isExpanded ? (
                  <UpOutlined title="Toggle Activity" />
                ) : (
                  <DownOutlined title="Toggle Activity" />
                )
              }
            />
          )}
          <Flex justify="flex-end" style={{ flex: 0.3 }}>
            <Flex justify="space-between" gap={'middle'}>
              {!isRestricted && (
                <Button
                  type="link"
                  onClick={() => onAddNewRow(index, row.projectId)}
                  disabled={
                    disabled ||
                    (row.category.toLowerCase() === en.Activities.Label.TimeOff
                      ? row.activityRows.length >=
                        row.activities.filter((a) => a.isDefault == false)
                          .length
                      : row.activityRows.length >= row.activities.length) ||
                    !row.isExpanded
                  }
                  icon={<PlusCircleFilled title="Add Activity" />}
                />
              )}
              <EditInput
                rowIndex={index}
                colIndex={-1}
                update={onChange}
                value={Number(value.toFixed(2))}
                isTotalInput
                max={rowHeaders.length * 24}
                disabled={disabled}
              />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
      {rowHeaders.map((col, colIndex) => (
        <Flex
          justify="center"
          key={`${row.projectId}-header-${colIndex}`}
          style={{
            flex: '1 1 0',
            minWidth: 0,
            margin: 'auto',
            padding: '0.75rem',
          }}
        >
          <EditInput
            rowIndex={index}
            colIndex={colIndex}
            update={update}
            value={Number(col?.duration.toFixed(2))}
            disabled={disabled}
          />
        </Flex>
      ))}
    </Flex>
  );
};
